import { useState } from "react";
import { saveShoppingItem } from "../api";

function getToday() { return new Date().toLocaleDateString("de-DE"); }
function getTime() { return new Date().toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" }); }

const CATEGORIES = ["Huelle", "Glass", "Zubehoer", "Spielzeug"];

export default function ShoppingScreen({ employee, onBack }) {
  const [category, setCategory] = useState("Huelle");
  const [product, setProduct] = useState("");
  const [note, setNote] = useState("");
  const [saved, setSaved] = useState([]);
  const [saving, setSaving] = useState(false);

  async function handleAdd() {
    if (!product.trim()) return;
    setSaving(true);
    await saveShoppingItem({
      date: getToday(),
      time: getTime(),
      employeeName: employee?.name,
      category,
      product: product.trim(),
      note: note.trim()
    });
    setSaved(prev => [...prev, { category, product, note }]);
    setProduct("");
    setNote("");
    setSaving(false);
  }

  return (
    <div style={{ display:"flex", flexDirection:"column", minHeight:"100vh", padding:"24px 18px 32px", backgroundColor:"#0A0A0A" }} className="fade-in">
      <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:24 }}>
        <button onClick={onBack} style={{ background:"#141414", border:"1px solid #222", color:"#555", width:36, height:36, borderRadius:10, cursor:"pointer", fontSize:18 }}>←</button>
        <div>
          <div style={{ color:"#F59E0B", fontSize:10, letterSpacing:3 }}>EINKAUFSLISTE</div>
          <div style={{ fontSize:20, fontWeight:700 }}>Was fehlt?</div>
        </div>
      </div>

      <div style={{ display:"flex", gap:8, marginBottom:16, flexWrap:"wrap" }}>
        {CATEGORIES.map(cat => (
          <button key={cat} onClick={() => setCategory(cat)} style={{ padding:"8px 16px", borderRadius:10, border:`1.5px solid ${category===cat?"#F59E0B":"#1E1E1E"}`, background:category===cat?"#F59E0B10":"transparent", color:category===cat?"#F59E0B":"#444", fontSize:12, fontWeight:700, cursor:"pointer" }}>{cat}</button>
        ))}
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:10, marginBottom:20 }}>
        <input type="text" placeholder="Produktname..." value={product} onChange={e=>setProduct(e.target.value)} style={{ padding:"14px 16px", borderRadius:12, border:"1px solid #1E1E1E", background:"#111", color:"#FFF", fontSize:15 }} />
        <input type="text" placeholder="Notiz (optional)..." value={note} onChange={e=>setNote(e.target.value)} style={{ padding:"14px 16px", borderRadius:12, border:"1px solid #1E1E1E", background:"#111", color:"#FFF", fontSize:15 }} />
        <button onClick={handleAdd} disabled={saving || !product.trim()} style={{ padding:"16px", borderRadius:14, border:"none", background:product.trim()?"linear-gradient(135deg,#F59E0B,#D97706)":"#1A1A1A", color:product.trim()?"#000":"#444", fontSize:16, fontWeight:700, cursor:product.trim()?"pointer":"default" }}>
          {saving ? "Speichern..." : "+ Hinzufuegen"}
        </button>
      </div>

      {saved.length > 0 && (
        <div>
          <div style={{ color:"#444", fontSize:10, letterSpacing:3, marginBottom:10 }}>HINZUGEFUEGT</div>
          <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {saved.map((item, i) => (
              <div key={i} style={{ background:"#111", border:"1px solid #22C55E30", borderRadius:12, padding:"12px 14px", display:"flex", alignItems:"center", gap:10 }}>
                <div style={{ width:8, height:8, borderRadius:"50%", background:"#22C55E" }} />
                <div>
                  <div style={{ fontSize:14, fontWeight:600 }}>{item.product}</div>
                  <div style={{ color:"#555", fontSize:11 }}>{item.category}{item.note ? " · " + item.note : ""}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
